<div
  *ngIf="currentScope"
  class="change-request-tracked">
  <scope-by-work-table
    [showCRDifferences]="true"
    [scopeVersion]="currentScope"
    [isEditable]="false"
    [currentChangeRequest]="currentChangeRequest"
    [deliverableMenuOptions]="deliverableMenuOptions"
    [componentMenuOptions]="componentMenuOptions"
    [mainColumnClass]="mainColumnClass"
    [componentMainColumnClass]="componentMainColumnClass"
    [roleMainColumnClass]="roleMainColumnClass"
    [sortedSections]="sections$ | async"
    [sortedDefaultSectionDeliverables]="deliverables$ | async"
    [cdnConfig]="cdnConfig"
    (onFetchDeliverable)="fetchDeliverable($event)" />
</div>
